// Runtime configuration for the website redesign.
//
// Reads build-time environment variables (Vue CLI exposes `process.env.VUE_APP_*`)
// and surfaces a single, defaulted config object consumed by navigation and the
// analytics bootstrap. Defaults are "off" so the launch state matches the
// requirements without any extra setup (Requirements 2.4, 12.4, 13.6).

/**
 * Coerce an environment variable value into a boolean.
 *
 * Truthy values are the strings "true", "1", "yes", and "on" (case-insensitive,
 * surrounding whitespace ignored). Anything else - including `undefined`, empty
 * strings, and unrecognized values - resolves to the provided default.
 *
 * @param {string|undefined} value - the raw env value
 * @param {boolean} [defaultValue=false] - value used when `value` is absent
 * @returns {boolean}
 */
export function parseBool(value, defaultValue = false) {
  if (value === undefined || value === null || value === '') {
    return defaultValue;
  }
  return ['true', '1', 'yes', 'on'].includes(String(value).trim().toLowerCase());
}

export const runtimeConfig = {
  features: {
    software: parseBool(process.env.VUE_APP_FEATURE_SOFTWARE, false), // Req 2
    login: parseBool(process.env.VUE_APP_FEATURE_LOGIN, false),       // Req 3
    blog: parseBool(process.env.VUE_APP_FEATURE_BLOG, false),         // Req 12
  },
  analytics: {
    measurementId: process.env.VUE_APP_ANALYTICS_ID || null,          // Req 13.6
  },
  links: {
    // Survey documentation (the thinkspatial-survey-docs VuePress site).
    //
    // Defaulted to the live host so the link works with no environment setup.
    // Configurable because the entra-sso spec plans to serve the documentation
    // from this application at `/docs` behind the same sign-in — when that
    // happens this becomes a config change (set it to `/docs`) rather than a
    // code change, and a relative value works because the nav renders whatever
    // is here as the href.
    docs: process.env.VUE_APP_DOCS_URL || 'https://docs.thinkspatial.com.au',
  },
};

export default runtimeConfig;
